import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useMoneyFormatter } from "@/lib/currency";
import { MetricCard, PageHeader, Section, Pill } from "@/components/ui-kit";
import { Users, Wallet, Banknote, AlertTriangle } from "lucide-react";

export default function CompanyDashboard() {
  const fmt = useMoneyFormatter();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/dashboard/company").then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);
  if (!data) return <div className="label">Loading…</div>;
  return (
    <div data-testid="company-dashboard">
      <PageHeader title="Company Overview" subtitle="Operations dashboard" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <MetricCard label="Customers" value={data.customers_total} icon={Users} testId="metric-customers" />
        <MetricCard label="Total Savings" value={fmt(data.savings_total)} icon={Wallet} accent="sage" testId="metric-savings" />
        <MetricCard label="Active Loans" value={data.active_loans} icon={Banknote} testId="metric-active-loans" sub={`${data.pending_loans} pending`} />
        <MetricCard label="Outstanding" value={fmt(data.outstanding_loan_balance)} accent="terracotta" icon={AlertTriangle} testId="metric-outstanding" sub={`${data.overdue_repayments} overdue`} />
      </div>
      <Section title="Recent Loans" testId="recent-loans">
        {data.recent_loans?.length ? (
          <table className="w-full text-sm">
            <thead><tr className="text-left">
              <th className="label py-2">Date</th><th className="label py-2">Customer</th><th className="label py-2">Method</th>
              <th className="label py-2 text-right">Principal</th><th className="label py-2 text-right">Outstanding</th><th className="label py-2 text-right">Status</th>
            </tr></thead>
            <tbody>
              {data.recent_loans.map((l) => (
                <tr key={l.id} className="border-t border-border">
                  <td className="py-2.5">{new Date(l.created_at).toLocaleDateString()}</td>
                  <td className="py-2.5 font-mono text-xs">{l.customer_id?.slice(0, 8)}…</td>
                  <td className="py-2.5">{l.method}</td>
                  <td className="py-2.5 text-right tabular-nums">{fmt(l.principal)}</td>
                  <td className="py-2.5 text-right tabular-nums">{fmt(l.outstanding_balance)}</td>
                  <td className="py-2.5 text-right"><Pill variant={l.status === "ACTIVE" ? "success" : l.status === "COMPLETED" ? "info" : l.status === "PENDING" ? "warning" : "default"}>{l.status}</Pill></td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : <div className="text-sm text-muted-foreground py-6 text-center">No loans yet.</div>}
      </Section>
    </div>
  );
}
